import * as z from 'zod';

/** Payload for the create-note modal. */
export const createNotePayloadSchema = z.object({
  orderId: z.union([z.string(), z.number()]),
});
export type CreateNotePayload = z.infer<typeof createNotePayloadSchema>;

/** Payload for the read-only notes list (opened from the "last note" cell). */
export const orderNotesPayloadSchema = z.object({
  orderId: z.union([z.string(), z.number()]),
});
export type OrderNotesPayload = z.infer<typeof orderNotesPayloadSchema>;
